function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useMemo } from 'react';
import getDisplayName from '../../../getDisplayName';
var isArray = function isArray(tbd) {
  return Array.isArray(tbd);
};
var isElement = function isElement(tbd) {
  return typeof tbd.props !== undefined;
};
function pruneStaticText(child) {
  var result = true;
  if (isElement(child)) {
    var props = child.props;
    var type = props.type,
      text = props.text;
    result = type !== 'text';
    if (!result) {
      result = text && text.length && text.length > 4;
    }
  }
  return result;
}
export default function withStaticTextPruning(WrappedComponent) {
  var Wrapped = function Wrapped(props) {
    var children = props.children,
      rest = _objectWithoutProperties(props, ["children"]);
    var _children = useMemo(function () {
      return isArray(children) ? children.filter(pruneStaticText) : [];
    }, [children]);
    return /*#__PURE__*/React.createElement(WrappedComponent, Object.assign({
      children: _children
    }, rest));
  };
  Wrapped.displayName = "WrapUiDisabledWidget(".concat(getDisplayName(WrappedComponent), ")");
  return Wrapped;
}